import { useRef } from "react";

import { FormProvider } from "react-hook-form";

import {
  PRACTITIONER_PROFILE_QUERY,
  SAVE_PATIENT_PROFILE_MUTATION,
  SAVE_YOUR_DETAILS_MUTATION
} from "@/graphql/accounts";
import useDjangoGraphqlForm from "@/hooks/form/useDjangoGraphqlForm";
import { PanelBoxV2 } from "@/tpo/Boxes";
import Center from "@/tpo/Center";

import EditFormButtons from "../EditFormButton";
import StudentPractitionerUpgrade from "../sections/StudentPractitionerUpgrade";
import YourDetailsSection from "../sections/YourDetails";

function getDefaultValues(practitionerProfile) {
  return {
    firstName: practitionerProfile.user.firstName || "",
    lastName: practitionerProfile.user.lastName || "",
    jobRole: practitionerProfile.jobRole || "",
    phoneNumber: practitionerProfile.phoneNumber || ""
  };
}

export default function YourDetailsForm({ practitionerProfile }) {
  const submitButtonRef = useRef();

  const api = useDjangoGraphqlForm({
    defaultValues: getDefaultValues(practitionerProfile),
    mutation: SAVE_YOUR_DETAILS_MUTATION,
    mutationName: "saveYourDetailsMutation",
    mutationOptions: {
      refetchQueries: [
        {
          query: PRACTITIONER_PROFILE_QUERY
        }
      ]
    },
    transformer: data => ({
      ...data
    }),
    handleSuccess: ({ data, api: { reset } }) => {
      reset(getDefaultValues(data.saveYourDetailsMutation.practitionerProfile));
      if (submitButtonRef.current) {
        submitButtonRef.current.setSuccessful(true);
        submitButtonRef.current.setPending(false);
      }
    },
    handleFailure: () => {
      if (submitButtonRef.current) {
        submitButtonRef.current.setSuccessful(false);
        submitButtonRef.current.setPending(false);
      }
    }
  });

  return (
    <>
      <FormProvider {...api.methods} submitButtonRef={submitButtonRef}>
        <form onSubmit={api.methods.handleSubmit(api.onSubmit)}>
          <YourDetailsSection>
            {api.methods.formState.isDirty && (
              <Center mt={40} gap={20}>
                <EditFormButtons
                  cancelButtonProps={{
                    "data-component-name": "practitionerProfileCancelButton"
                  }}
                  saveButtonProps={{
                    "data-component-name": "practitionerProfileSaveButton"
                  }}
                />
              </Center>
            )}
          </YourDetailsSection>
        </form>
      </FormProvider>
    </>
  );
}
